import $ from 'jquery';
import BaseEvent from './base-event';

export default class BtnEvents extends BaseEvent {
  constructor() {
    super({
      event_id: '22',
      category: 'button',
      action: 'click',
    });

    this.init();
  }

  init() {
    $('a.mc-button').on('click', (e) => {
      const widgetName = $(e.currentTarget).parents(`[${this.widgetNameSelector}]`).attr(this.widgetNameSelector);
      const label = $(e.currentTarget).hasClass('js-fixtures-notify-me')
      ? this.getLabel($(e.currentTarget).find('.js-notify-label'))
      : this.getLabel($(e.currentTarget));

      this.fireEvent({
        label: this.toNormalizedString(label),
        destination_url: e.currentTarget.href,
        widget_name: widgetName ? this.toNormalizedString(widgetName) : null,
      });
    });

    $('.mc-header-locale-selector, .mc-header-open-mobile, .mc-mobile-menu__close').on('click', (e) => {
      this.fireEvent({
        label: this.toNormalizedString(e.currentTarget.title),
      });
    });
  }
}
